<template>
  <div class="sample-overlay" @click.self="$emit('close')" @keydown.esc="$emit('close')">
    <section role="dialog" aria-modal="true" aria-label="샘플 베팅 상세">
      <h2>베팅 상세 · 샘플</h2>
      <p>베팅번호: {{ meta.betId }}</p><p>회원: {{ meta.memId }}</p><p>게임: {{ meta.gameName }}</p>
      <p>베팅: {{ numberWithCommas(meta.betAmt) }} / 당첨: {{ numberWithCommas(meta.betWinAmt) }}</p>
      <p>{{ meta.regDate }}</p><p>실제 게임 또는 외부 벳디테일 서비스에는 연결하지 않습니다.</p>
      <button ref="close" type="button" @click="$emit('close')">닫기</button>
    </section>
  </div>
</template>
<script>
export default { props: { meta: { type: Object, required: true } }, emits: ['close'], mounted () { this.$refs.close.focus() } }
</script>
<style scoped>
.sample-overlay { position: fixed; inset: 0; background: #000b; z-index: 10000; display: grid; place-items: center; } section { background: #202b3c; color: #fff; padding: 30px; border-radius: 10px; max-width: 90vw; } h2 { font-size: 22px; } p { margin: 15px 0; } button { padding: 10px 25px; background: #30ba79; color: #fff; border-radius: 4px; }
</style>
